/**
 * @template T
 */
class Observer {
  /** @type {Array<SubscribeFn<T>>} */
  observers = [];

  /**
   * @param {T} data
   */
  broadcast (data) {
    this.observers.forEach(subscriber => subscriber(data));
  }

  /**
   * @param {SubscribeFn<T>} fn
   */
  subscribe (fn) {
    this.observers.push(fn);
    return fn;
  }

  /**
   * @param {SubscribeFn<T>} fn
   */
  unsubscribe (fn) {
    this.observers = this.observers.filter(entry => entry !== fn);
    return fn;
  }
}

/**
 * @template T
 * @callback SubscribeFn
 * @param {T} data
 * @returns {void}
 */

export default Observer;
